var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.833 8.333h5a.836.836 0 00.834-.833V.833A.836.836 0 005.833 0h-5A.836.836 0 000 .833V7.5c0 .458.375.833.833.833zm0 6.667h5a.836.836 0 00.834-.833v-3.334A.836.836 0 005.833 10h-5a.836.836 0 00-.833.833v3.334c0 .458.375.833.833.833zm8.334 0h5a.836.836 0 00.833-.833V7.5a.836.836 0 00-.833-.833h-5a.836.836 0 00-.834.833v6.667c0 .458.375.833.834.833zM8.333.833v3.334c0 .458.375.833.834.833h5A.836.836 0 0015 4.167V.833A.836.836 0 0014.167 0h-5a.836.836 0 00-.834.833z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.25322b7342ff5c0ceabfaf5c3597d391.svg";
export { ForwardRef as ReactComponent };